let headingIdCounter = 0;

export const generateHeadingId = (text) => {
  const baseId = text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\p{L}\p{N}-]/gu, ""); // Allows Unicode letters/numbers

  if (!baseId) {
    headingIdCounter += 1;
    return `heading-${headingIdCounter}`;
  }

  return baseId;
};
